export default {
  path: '/wecode/statistic',
  auth: true,
  preload: true,
  key: 'statistic',
  component: () => import('./index')
};
